<template>
  <v-dialog v-model="show" width="750">
    <v-card>
      <v-card-title primary-title>
        Submitted reports
      </v-card-title>

      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Reported by</th>
              <th width="50%" class="text-left">Reason</th>
              <th class="text-left">Reported on</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="report in reports" :key="report.id">
              <td>{{ report.reporter.full_name }}</td>
              <td>{{ report.reason.label }}</td>
              <td>{{ report.reported_at | diffForHumans }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="show = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedReports: null
  },
  data () {
    return {
      show: this.value,
      reports: this.selectedReports
    }
  },
  filters: {
    diffForHumans: (date) => {
      if (!date) {
        return null
      }

      return dayjs.utc(date).format('MMM DD, YYYY hh:mm A')
    }
  },
  watch: {
    value (val) {
      this.show = val
    },
    selectedReports (val) {
      this.reports = val.reports
    },
    show (val) {
      this.$emit('input', val)
    }
  }
}
</script>
